export default "__VITE_ASSET__c72b48e0__"